import { Grid } from 'antd';

const { useBreakpoint } = Grid;

export const useResponsiveness = () => {
  const screens = useBreakpoint();

  const isMobile = screens['xs'];
  const isDesktop = screens['lg'] || screens['xl'] || screens['xxl'];
  const isDesktopXl = screens['xl'] || screens['xxl'];
  const isDesktopXxl = screens['xxl'];
  const isTablet = (!isMobile && !isDesktop) || (screens['sm'] && !isDesktop);
  const isSmallTablet = screens['sm'] && !screens['md'];

  const isSmallScreen = isMobile || isTablet;
  return {
    isMobile,
    isTablet,
    isDesktop,
    isDesktopXl,
    isDesktopXxl,
    isSmallScreen,
    isSmallTablet,
  };
};
